import "reflect-metadata";
import { InterfaceNames } from 'InterfaceNames';
import { dicontainer } from 'DIContainer';
import * as React from "react";
import * as ReactDOM from 'react-dom';
import BeerService from 'Services/BeerService';
import ContactService from "Services/ContactService";
import HttpService from 'Services/Http/HttpService';
import Main from "Main";
import PageConfigurationProvider from 'Pages/PageConfigProvider';
import PageNavigationController from "PageNavigation/PageNavigationController";

export default class Startup {

    constructor() {
        this.ConfigureServices();
        this.ConfigureViewServices();
        ReactDOM.render(<Main />, document.getElementById("react-container"));
    }
    
    private ConfigureViewServices() {
        dicontainer.bind(InterfaceNames.IPageConfigurationProvider).to(PageConfigurationProvider).inSingletonScope();
    }

    private ConfigureServices() {
        dicontainer.bind<BeerService>(BeerService).toSelf().inSingletonScope();
        dicontainer.bind<ContactService>(ContactService).toSelf().inSingletonScope();
        dicontainer.bind<HttpService>(HttpService).toSelf().inSingletonScope();
        dicontainer.bind<PageNavigationController>(PageNavigationController).toSelf().inSingletonScope();
    }
}

new Startup();